import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinkComponent } from './link.component';
import { IconModule } from '../icon/icon.module';
import { TextModule } from '../text/text.module';

@NgModule({
  declarations: [LinkComponent],
  imports: [CommonModule, IconModule, TextModule],
  exports: [LinkComponent],
})
export class LinkModule {}
